import { useAuthStore } from '../store/auth';
import { apiClient, updateApiClientToken } from './api-client';

/**
 * One-time boot check for protected apps.
 *
 * Local LMS sessions are stored by the auth store. Refresh the account record
 * on every protected-app boot so administrative updates—especially a newly
 * assigned NIP—are not hidden behind an older browser-local profile.
 */
export async function bootstrapAuth(): Promise<void> {
  const { token, setAuth } = useAuthStore.getState();
  if (token) {
    updateApiClientToken(token);

    try {
      const user = await apiClient.auth.me();
      setAuth(token, user);
    } catch {
      // The API client handles a 401 by clearing the session. For temporary
      // network failures, keep the previously saved profile usable instead of
      // blocking access to the participant portal.
    }
  }
}
